import { CommonModule } from "@angular/common";
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
} from "@angular/core";

import { map, Subscription, switchMap } from "rxjs";

import { Context } from "@hermes/app-core";
import {
    FeatureFlagFacade,
    SEO_COMBINED_FACETS_ACTIVATION_ON_GRID,
} from "@hermes/states/flipper";
import { GridFacade } from "@hermes/states/grid-filters-state";
import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";

import { GridPageModule } from "../../grid-page.module";

@Component({
    selector: "h-grid-filter-section-header",
    standalone: true,
    imports: [CommonModule, SrOnlyNoSnippetDirective, GridPageModule],
    templateUrl: "./grid-filter-section-header.component.html",
    styleUrl: "./grid-filter-section-header.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridFilterSectionHeaderComponent implements OnInit, OnDestroy {
    /** Number of items in the current collection */
    public collectionSize?: number;

    public hideTotalUpdatedItems = true;

    public currentCategory$ = this.gridFacade.category$;
    public isSearchGrid$ = this.gridFacade.isSearchGrid$;
    public facetDisplayName$ = this.featureFlagFacade
        .isActivated(SEO_COMBINED_FACETS_ACTIVATION_ON_GRID)
        .pipe(
            switchMap(() => this.gridFacade.facet$),
            map((facet) => facet.facetDisplayName),
        );

    private subscription: Subscription = new Subscription();

    constructor(
        private cd: ChangeDetectorRef,
        private gridFacade: GridFacade,
        private featureFlagFacade: FeatureFlagFacade,
        private context: Context,
    ) {}

    public get isBrowserMode(): boolean {
        return this.context.isInBrowserMode();
    }

    /** Subscribe on every event of the observable from filter groups service */
    public ngOnInit(): void {
        this.subscription.add(
            this.gridFacade.total$.subscribe((total) => {
                // for first total, hide screen reader
                this.hideTotalUpdatedItems = Boolean(
                    this.collectionSize === undefined || total === undefined,
                );
                this.collectionSize = total;
                this.cd.markForCheck();
            }),
        );
    }

    /**
     * Unsubcribe to next() event if the component is destroy
     */
    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
